import { createPaginatedKey } from "api/keys";

export const bankAccountsKeys = {
  banks: () => ["banks"],
  bankAccounts: createPaginatedKey("bankAccounts"),
  bankAccountsTransactions: createPaginatedKey("bankAccountsTransactions"),
  bankAccountsTransaction: (id: string) => ["bankAccountTransaction", id],
};
